import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private intermediaryUrl = environment.intermediaryUrl;
  private isAuthenticatedVal = false;
  private currentUserDetails: any = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private httpService: HttpService,
    private modalService: NgbModal,
  ) {}

  login(credentials: { username: string; password: string }): Observable<any> {
    return this.http.post(`${this.intermediaryUrl}auth/login`, credentials, { 
      headers: this.httpService.getHeaders(),
      withCredentials: true
    });
  }

  initializeAuth(): Promise<boolean> {
    return new Promise((resolve) => {
      this.http.get(`${this.intermediaryUrl}users/profile`, { withCredentials: true }).subscribe({
        next: (profile: any) => {
          this.isAuthenticatedVal = true;
          this.currentUserDetails = profile;
          localStorage.setItem('userData', JSON.stringify(profile));
          resolve(true);
        },
        error: () => {
          this.isAuthenticatedVal = false;
          this.currentUserDetails = null;
          resolve(false);
        }
      });
    });
  }

  verifyCredentials(password: string): Observable<any> {
    const username = this.currentUserDetails?.username || JSON.parse(localStorage.getItem('userData') || '{}')?.username;
    return this.login({ username, password });
  }

  logout() {
    this.modalService.dismissAll();
    // Attempt backend logout to clear session cookies on server
    this.http.post(`${this.intermediaryUrl}auth/logout`, {}, { withCredentials: true }).subscribe({
      next: () => this.clearLocalSession(),
      error: () => this.clearLocalSession()
    });
  }

  clearLocalSession() {
    this.isAuthenticatedVal = false;
    this.currentUserDetails = null;
    const rememberMe = localStorage.getItem('rememberMe');
    localStorage.clear();
    if (rememberMe) {
      localStorage.setItem('rememberMe', rememberMe);
    }
    // Synchronize logout across tabs
    localStorage.setItem('logout-event', Date.now().toString());
    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    return this.isAuthenticatedVal;
  }

  setAuthenticated(status: boolean) {
    this.isAuthenticatedVal = status;
  }

  setToken(token: string) {
    // No-op for cookie auth compatibility
    this.isAuthenticatedVal = true;
  }

  rememberMe(isRemember: boolean) {
    localStorage.setItem('rememberMe', isRemember.toString());
  }

  getToken(): string | null {
    return null;
  }

  getCurrentUser() {
    return this.currentUserDetails;
  }
}